// Cathaya Premium Theme JS - Enhanced Animations

document.addEventListener('DOMContentLoaded', function() {
  
  // Newsletter form with animation
  const form = document.querySelector('.c-signup');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = form.querySelector('button');
      if (!btn) { form.reset(); return; }
      const originalText = btn.textContent;

      // Add loading state
      btn.classList.add('is-loading');
      
      setTimeout(() => {
        btn.classList.remove('is-loading');
        btn.textContent = 'Thank you! 💐';
        btn.style.background = 'linear-gradient(135deg, #566f4d, #7a9e6d)';
        
        setTimeout(() => { 
          btn.textContent = originalText;
          btn.style.background = '';
          form.reset(); 
        }, 2500);
      }, 800);
    });
  }

  // Enhanced Sticky Header
  const header = document.querySelector('.c-header');
  let lastScroll = 0;
  
  if (header) {
    window.addEventListener('scroll', function() {
      const currentScroll = window.scrollY;
      
      if (currentScroll > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // Scroll Animations - Intersection Observer
  const animatedElements = document.querySelectorAll('.animate-on-scroll, .c-product-card, .c-section-head, .c-editorial-slide, .c-review, .c-promise');
  
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          // Add staggered delay
          setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, index * 100);
          
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    animatedElements.forEach(el => observer.observe(el));
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      // Skip non-fragment links: "#", "#!", and anything that isn't a valid CSS id selector
      if (!href || href === '#' || href === '#!' || href.length < 2) return;
      let target = null;
      try { target = document.querySelector(href); } catch (_) { /* invalid selector — let browser handle it */ return; }
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Add animation classes to elements
  const sections = document.querySelectorAll('.c-section');
  sections.forEach(section => {
    section.classList.add('animate-on-scroll');
  });

  // Parallax effect for hero images (rAF-throttled, skips when off-screen)
  const heroImages = document.querySelectorAll('.c-hero-media img');

  if (heroImages.length > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let ticking = false;
    let lastScrollY = 0;
    const onScroll = () => {
      lastScrollY = window.pageYOffset;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const rate = lastScrollY * 0.3;
        heroImages.forEach(img => {
          // Only update if the image is roughly in viewport — saves work on long pages
          const rect = img.getBoundingClientRect();
          if (rect.bottom < -200 || rect.top > window.innerHeight + 200) return;
          img.style.transform = `translateY(${rate}px) scale(1.1)`;
        });
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Button ripple effect
  document.querySelectorAll('.c-btn').forEach(button => {
    button.addEventListener('click', function(e) {
      const rect = this.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      const ripple = document.createElement('span');
      ripple.style.cssText = `
        position: absolute;
        background: rgba(255,255,255,0.4);
        border-radius: 50%;
        transform: scale(0);
        animation: ripple 0.6s linear;
        pointer-events: none;
        left: ${x}px;
        top: ${y}px;
        width: 20px;
        height: 20px;
        margin-left: -10px;
        margin-top: -10px;
      `;
      
      this.style.position = 'relative';
      this.style.overflow = 'hidden';
      this.appendChild(ripple);
      
      setTimeout(() => ripple.remove(), 600);
    });
  });

  // Add ripple keyframe dynamically
  const style = document.createElement('style');
  style.textContent = `
    @keyframes ripple {
      to {
        transform: scale(4);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);
});
